/*eslint @typescript-eslint/no-empty-function: "off"*/
import React from 'react';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { RouteComponentProps } from '@reach/router';
import { IUsers, RootState } from 'store/store';
import DocumentList from './DocumentList';
import DocumentInput from './DocumentInput';
import { display } from 'components/ErrorView/ErrorDialog';
import { DocumentsContainer } from './styles';
import { appDispatch } from 'store/store';
import { ICompany } from 'store/companies/companiesTypes';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import {
  addCompanyDocument,
  addCompanyDocumentFn,
  removeCompanyDocument,
  removeCompanyDocumentFn,
} from 'store/companies/companiesSlice';

interface IStateToProps {
  company: ICompany;
  thisUser: IThisUserState;
  users: IUsers;
}

interface IDispatchToProps {
  addDocument: (
    type: string,
    file: any
  ) => ReturnType<typeof addCompanyDocumentFn>;
  deleteDocument: (
    type: string,
    companyId: number
  ) => ReturnType<typeof removeCompanyDocumentFn>;
}

interface IOwnProps {
  companyId?: string;
}

type IComponentProps = IOwnProps &
  IStateToProps &
  IDispatchToProps &
  RouteComponentProps;

interface ICompanyDocumentsState {
  loading: string | null;
}

class CompanyDocuments extends React.Component<
  IComponentProps,
  ICompanyDocumentsState
> {
  constructor(props: IComponentProps) {
    super(props);
    this.state = {
      loading: null,
    };
  }

  deleteDocumentItem = (type: string, companyId: number) => {
    this.setState({ loading: type });
    this.props
      .deleteDocument(type, companyId)
      .then(() => {
        this.setState({ loading: null });
      })
      .catch((err: any) => {
        this.setState({ loading: null });
        display(err.data.message);
      });
  };

  addDocumentItem = (type: string, file: any) => {
    return this.props.addDocument(type, file);
  };

  render() {
    const { company, companyId } = this.props;
    const documents = company.documents;
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <DocumentsContainer>
          <DocumentInput
            addDocument={this.addDocumentItem}
            companyId={Number(companyId)}
          />
          <DocumentList
            companyId={Number(companyId)}
            documents={documents}
            deleteDocument={this.deleteDocumentItem}
          />
        </DocumentsContainer>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const companyId = Number(props.companyId);
  const company = state.companies.data[companyId];
  const thisUser = state.thisUser;
  const users = state.users;

  return { users, company, thisUser };
};

const mapDispatchToProps: MapDispatchToProps<IDispatchToProps, IOwnProps> = (
  _,
  props
) => {
  return {
    addDocument: (type: string, file: any) =>
      appDispatch(
        addCompanyDocument({
          companyId: Number(props.companyId) || 0,
          type,
          file,
        })
      ),
    deleteDocument: (type: string, companyId: number) =>
      appDispatch(removeCompanyDocument({ companyId, type })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDocuments);
